import { styled } from 'styled-components';

import ErrorSVG from '../assets/error-icon.svg?react';

export const ErrorIcon = styled(ErrorSVG)`
  width: 24px;
  height: 24px;
`;
